module.exports = __webpack_public_path__ + "static/media/iphone_12_white.3fee4d90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_12_white.png
// module id = 2087
// module chunks = 0